export enum ComponentPrefix {
  BUTTON_NEXT = "button-next",
  BUTTON_PREVIOUS = "button-previous",
  BUTTON_CONSENT = "button-consent",
  BUTTON_DETAILS = "button-details",
  BUTTON = "button",
  LINK = "link",
  RADIO = "radio",
  INPUT = "input",
  CHECKBOX = "checkbox",
}

export enum AppPartName {
  ACCEPT = "Accept",
  CHECK_PRICE = "Product info",
  CHECK_PRICE_STEP = "Check price",
  CHECKOUT_STEP = "Product details",
  LOGIN = "Login",
  LOGIN_SUCCESS = "Login successful",
  UPSELL = "Upsell",
  OFFER = "Cart",
  OFFER_ACCEPT = "Offer accept",
  OFFER_ACCEPT_PRINT_FRIENDLY = "Offer accept print friendly",
  CART_REDIRECT = "Cart redirect",
  CONFIRM = "Confirm",
  RECEIPT = "Receipt",
  PRODUCT_REDIRECT = "Product redirect",
}

export enum Login {
  BANK_ID = "bankid",
  NIN = "nin",
}

export const funnelName = "buy-insurance-web";
